<template>
  <el-dialog title="批量撤版" :visible.sync="dialogVisible" width="80%" center class="dialog-revoke-history">
    <div class="header">
      <span>撤版记录</span>
      <span style="cursor: pointer;" @click="dialogVisible = false">返回</span>
    </div>
    <el-table v-loading="loading" :data="tableData" border :header-cell-style="setHeaderCellStyle" :cell-style="setCellStyle">
      <el-table-column prop="keyword" label="撤版文章关键词"> </el-table-column>
      <el-table-column prop="formatTime" label="撤版时间"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <div class="option-button" @click="downloadItem(scope.row)">下载撤版记录</div>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer" class="dialog-footer">
      <div class="page-counts">
        共 <span>{{ totalCount }}</span> 条记录
      </div>
      <el-pagination @current-change="getRecordList" :total="totalCount" :page-size="pageSize" :current-page.sync="currentPageNo" small="small" :layout="'prev, pager, next'" />
    </div>
  </el-dialog>
</template>
<script>
import { mapState } from 'vuex'
import api from '@api/paperManager'
import moment from 'moment'
export default {
  name: 'RevokeHistoryDialog',
  data() {
    return {
      totalCount: 0,
      currentPageNo: 1,
      tableData: [],
      dialogVisible: false,
      pageSize: 10,
      loading: false
    }
  },
  computed: {
    userName() {
      return localStorage.getItem('username')
    }
  },

  methods: {
    downloadItem(row) {
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = `${window.PROJECT_CONFIG.BASE_URL}/ebook/revokeLayout/exportRevokeRecord?id=${row.id}`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    revoke() {
      const param = {
        baoZhiName: this.baozhiName,
        publishDate: this.fromDate || '',
        // publishDateStart: this.fromDate || '',
        // publishDateEnd: this.toDate || '',
        title: this.queryName,
        userName: this.userName
      }
      api.revoke(param).then((res) => {
        this.$message({
          message: res.data.message,
          type: res.status === 200 && res.data.status === 0 ? 'success' : 'error'
        })
      })
    },
    viewItem(item) {
      let path = '/digitalArticle'
      let routeUrl = this.$router.resolve({
        path: path,
        query: { id: item.id }
      })
      window.open(routeUrl.href, '_blank')
    },
    setHeaderCellStyle(options) {
      if (options.columnIndex !== 0 && options.columnIndex !== 1) {
        return { 'background-color': '#fafafa', 'text-align': 'center', color: '#333' }
      } else {
        return { 'background-color': '#fafafa', color: '#333' }
      }
    },
    setCellStyle(options) {
      if (options.columnIndex !== 0 && options.columnIndex !== 1) {
        return 'text-align: center'
      }
    },
    getRecordList() {
      console.log(111)
      const param = {
        pageNo: this.currentPageNo,
        pageSize: 10,
        userName: this.userNamef
      }
      this.loading = true
      api.getEpaperRevokeLayoutByPage(param).then((res) => {
        if (res.status === 200 && res.data.status === 0) {
          let data = res.data.data
          this.tableData = data.content.map((item) => {
            return {
              ...item,
              formatTime: item.createTime ? moment(item.createTime).format('YYYY-MM-DD') : ''
            }
          })
          this.totalCount = data.totalElements
        }
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-revoke-history {
  .header {
    padding-bottom: 25px;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
  }
  .dialog-footer {
    display: flex;
    justify-content: space-between;
    ::v-deep .el-pagination {
      float: none;
    }
  }
  ::v-deep .el-dialog__body {
    padding-bottom: 10px;
  }
  .option-button {
    display: inline-block;
    cursor: pointer;
    color: #df5813;
  }
  .page-counts {
    background-color: #fff;
    text-align: center;
    span {
      color: #df5813;
    }
  }
}
</style>
